import styled from 'styled-components';
import { mediaMinWidth, FunctionColor } from '@lux/core';
import { DimensionsXs, DimensionsSm } from '../../../tokens/dimensions';
import { Layout } from '../../../tokens/layout';
import { CartItemsLayout } from './CartItems/styles';
var CartLayout;
(function (CartLayout) {
    CartLayout[CartLayout["width"] = 300] = "width";
})(CartLayout || (CartLayout = {}));
const calculateCartMaxHeight = ({ isOpen, itemsCount, cartInfoHeight }) => {
    if (!isOpen) {
        return 0;
    }
    if (itemsCount <= 0) {
        return 300;
    }
    const maxHeight = cartInfoHeight + CartItemsLayout.maxHeight;
    return maxHeight;
};
export const Wrapper = styled.div.withConfig({ displayName: "Wrapper", componentId: "sc-va3ki5" }) `display:block;position:fixed;top:${DimensionsXs.headerHeight};z-index:${Layout.zIndex + 1};right:0;width:100%;height:${({ isOpen }) => (isOpen ? `calc(100vh - ${DimensionsXs.headerHeight})` : 0)};visibility:${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};box-sizing:border-box;flex-wrap:nowrap;background:${({ itemsCount }) => (itemsCount !== 0 && FunctionColor.function5) ||
    (itemsCount === 0 && FunctionColor.function0)};overflow:hidden;box-shadow:0px 4px 8px rgba(0, 0, 0, 0.15);transition-property:height,max-height,visibility;transition-duration:0.7s;transition-timing-function:cubic-bezier(0, 1, 0.7, 1);${mediaMinWidth.sm}{position:absolute;top:${DimensionsSm.headerHeight};width:${CartLayout.width}px;height:auto;max-height:${calculateCartMaxHeight}px;}`;
export const Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-j7i20z" }) `overflow-y:hidden;box-sizing:border-box;padding:0 16px;${mediaMinWidth.sm}{max-height:${props => calculateCartMaxHeight(props)}px;padding:0 12px;}`;
export const CartItemsContainer = styled.div.withConfig({ displayName: "CartItemsContainer", componentId: "sc-q703th" }) ``;
//# sourceMappingURL=styles.js.map